import { useEffect } from 'react';

export const useMount = (fn: () => void) => {
  useEffect(() => {
    fn();
    // [] — значит, вызывается только при монтировании
  }, []);
};
